/**
 * @module web/util/api-hostname
 * @description The one place that decides which API host to talk to, based
 * on which host the app itself is being served from. Four call sites
 * (util/api.js, util/rtk-api.ts, util/error-reporting.ts, util/utils.ts)
 * used to each carry their own copy of this exact 3-way branch -- this is
 * the single source of truth they now share.
 *
 * Returns the bare hostname only (no protocol, no path) so callers that want
 * an HTTPS URL, an HTTP URL (local dev), or a WS/WSS URL can each build
 * their own prefix on top without this module having to guess which one
 * they need.
 */
export const resolveApiHostname = (): string => {
	const hostname = window.location.hostname
	if (hostname === 'localhost') return 'api.localhost'
	if (hostname.includes('staging.')) return 'api.staging.allforonelearn.com'
	return 'api.allforonelearn.com'
}
